module.exports = __webpack_public_path__ + "static/img/menage5.e0bc047e.jpg";